module.exports = __webpack_public_path__ + "static/media/albumThree.d7ea9429.jfif";